import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

const transformFiltersForTracking = (filters: Filter[]) => {
  const validFilters = filters.filter(({ value }) =>
    Array.isArray(value) ? !!value?.length : !!value,
  );
  const filterName = validFilters.map(filter => filter.id).join(',');
  const filterValues = validFilters.map(({ value }) =>
    Array.isArray(value) ? value.join(',') : String(value),
  );

  return {
    filterName,
    filterValues,
  };
};

export { transformFiltersForTracking };
